export const mapExtToMimes = {
  '.epub': ['application/epub+zip', 'application/epub'],
  '.zip': [
    'application/zip',
    'application/zip-compressed',
    'application/x-zip-compressed',
  ],
}
